import { Vue, Component, Prop } from 'vue-property-decorator';
import type { CreateElement, VNode } from 'vue';
import type { ElForm } from 'element-ui/types/form';
import cloneDeep from 'lodash/cloneDeep';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import Upload from '../upload/upload.vue';
import style from './bindClassStyle.vue';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils } from '@/util';
const isset = QinggerLibUtils.isset;

@DialogFactory
@Component({
  mixins: [style],
  components: {
    Upload,
  },
})
export default class bindClassDialog extends IPSDialog {
  title = '绑定主档分类';

  width = '700px';

  $refs: {
    tree: ElForm;
  };

  attrSelected = {
    classId: '',
    attrList: [],
  };

  // 是否展示前端排序
  sortShow = false;

  shareImage = ''

  shareInfo = ''
  public options = [
    {
      value: 1,
      label: '上新时间',
    },
    {
      value: 7,
      label: '库存降序',
    },
    {
      value: 5,
      label: '销量降序',
    },
    {
      value: 6,
      label: '折扣降序',
    },
    {
      value: 4,
      label: '价格升序'
    },
    {
      value: 3,
      label: '价格降序'
    }
  ];

  // 前端排序关键字
  public sortValue = 1;
  /**
   * 分类列表树
   */
  treeList: ItemArray<any> = [];

  /**
   * 所有主档分类列表
   */
  connectedClass: ItemArray = [];

  /**
   * 选择的主档分类
   */
  selectConnectedClass: Array<string> = [];

  /**
   * 最大选择数量
   */
  limitNum = 6;

  /**
   * 默认选中
   */
  defaultCheckedKeys = [];

  /**
   * 数据源 当有数据源的时候不需要调用接口获得
   */
  dataSource = null;

  props = { children: 'list', label: 'value_name' };

  nodeKey = 'value_no';

  formTitle = '一级主档分类';

  tips = '请在此处绑定商品的主档分类，最多可绑定6个一级主档分类，下级主档分类不做限制';

  getResults() {
    // @ts-expect-error
    const selectedList: ItemArray = this.$refs.tree.getCheckedNodes() || [];
    return selectedList;
  }

  created() {
    this.clearData();
    if (Array.isArray(this.dataSource)) {
      this.connectedClass = this.dataSource.map((v) => {
        v.value_name = v.className;
        v.value_no = v.classId;
        v.class_code = v.classId;
        v.attrName = v.className;
        v.attrCode = v.classId;
        v.childrenValueList = [v.classId].concat(this.computedDataSource(v.children).result);
        v.list = this.computedDataSource(v.children).list;
        v.isLeafe = !v.children || !v.children.length;
        return v;
      });
      this.treeList = this.connectedClass.filter((v) => {
        return this.defaultCheckedKeys.some(val => v.childrenValueList.includes(val));
      });
      this.selectConnectedClass = this.treeList.map(v => v.value_no);
    } else {
      this.getAttributeList().then(() => {
        this.treeList = this.connectedClass.filter((v) => {
          return this.defaultCheckedKeys.some(val => v.childrenValueList.includes(val));
        });
        this.selectConnectedClass = this.treeList.map(v => v.value_no);
      });
    }
  }

  beforeConfirm() {
    const results = this.getResults();
    if (!results || !results.length) {
      this.confirmloading = false;
      this.$message.warning('请选择分类');
      return;
    }
    if (!this.footer) {
      const result = { selectList: results, sortValue: this.sortValue, shareImage: this.shareImage, shareInfo: this.shareInfo };
      this.$emit('result', result);
    } else {
      this.$emit('result', results);
    }
    this.$emit('hidden');
  }

  /**
   * 数据初始化
   */
  clearData() {
    this.treeList = [];
    this.connectedClass = [];
    this.selectConnectedClass = [];
    this.attrSelected.classId = '';
    this.attrSelected.attrList = [];
  }

  computedTree(list = [], result = []) {
    list.forEach((v) => {
      v.isLeafe = !v.list || !v.list.length;
      result.push(v.value_no);
      if (v.list && v.list.length) {
        this.computedTree(v.list, result);
      }
    });
    return { result, list };
  }

  computedDataSource(list = [], result = []) {
    list.forEach((v) => {
      v.isLeafe = !v.children || !v.children.length;
      result.push(v.classId);
      if (v.children && v.children.length) {
        this.computedTree(v.children, result);
      }
    });
    return { result, list };
  }

  /**
   * 获取关联分类
   */
  public getAttributeList(): Promise<any> {
    return IPSService.getAttrTreeList().then((res) => {
      if (isset(res, 'list')) {
        this.connectedClass = res.list.map((v) => {
          v.value_name = v.attrName;
          v.value_no = v.attrCode;
          v.class_code = v.attrCode;
          v.childrenValueList = [v.attrCode].concat(this.computedTree(v.list).result);
          v.list = this.computedTree(v.list).list;
          v.isLeafe = !v.list || !v.list.length;
          return v;
        });
      }
    });
  }

  /**
   * 选中的关联分类发生变化时
   */
  public selectClassChange(): void {
    this.treeList = this.connectedClass.filter(v => (this.selectConnectedClass as Array<string>).includes(v.value_no));
  }

  checkedKeys(): Array<string> {
    const result = [...this.attrSelected.attrList.map(v => v.attrValues.split(','))].flat();
    return result;
  }

  /**
   * 选中或取消时回调
   */
  checkChange() {
    // @ts-expect-error
    this.defaultCheckedKeys = this.$refs.tree.getCheckedKeys() || [];
    // @ts-expect-error
    const selectedList: ItemArray = this.$refs.tree.getCheckedNodes() || [];
  }

  onClose() {
    this.$emit('hidden');
  }

  mounted() {
    const list = this.options.map((i) => {
      return i.value;
    });
    if (!list.includes(this.sortValue)) {
      this.sortValue = 1;
    }
  }
  uploadSuccess(res: HttpAPIRetItem<any>) {
    this.shareImage = res.content;
  }
  reFooter(h) {
    return (
      <div>
        <div class="formWrapper r-mt-10 border-bottom-white">
          <span>前端排序
            <el-select class="wid-70 r-ml-14" v-model={this.sortValue}>
              {this.options.map((item) => {
                return <el-option key={item.value} label={item.label} value={item.value}></el-option>;
              })}
            </el-select>
          </span>
          <p class="flex r-pb-14">
            <span class="r-mt-14 r-mr-14">分享配置</span>
            <Upload noDelete={false} onImgUploadSuccess={val => this.uploadSuccess(val)} fileList={false} img={this.shareImage} maxSize={300} />
            <div class="r-ml-14 r-mt-14">
              <el-input class="wid-160" v-model={this.shareInfo} placeholder="请输入分享描述信息" />
              <p class="tip blockTip r-mt-58">注1：建议图片分辨率为800*640px；</p>
              <p class="tip blockTip">注2：图片大小不超过300k，支持jpg、jpeg、gif、png格式。</p>
            </div>
          </p>
        </div>
        <div class="fr line-height-56 hei-28">
          <el-button onClick={() => this.onClose()}>关闭</el-button>
          <el-button type="primary" onClick={() => this.beforeConfirm()}>
            确认
          </el-button>
        </div>
      </div>
    );
  }

  renderContent(h: CreateElement): VNode {
    return (
      <div class="dialog">
        <div class="formTitle">{this.formTitle}</div>
        <div class="formItem">
          <el-select class="tagSelect" v-model={this.selectConnectedClass} multiple filterable allow-create default-first-option multiple-limit={this.limitNum} placeholder="最多选择6个标签" onChange={this.selectClassChange.bind(this)}>
            {this.connectedClass.map((item, index) => {
              return <el-option key={index} label={item.attrName} value={item.attrCode} />;
            })}
          </el-select>
        </div>
        <div class="formItem checkboxGroupWrapper hei-150 overflow-auto-y">
          {h('el-tree', {
            ref: 'tree',
            attrs: {
              'props': this.props,
              'data': this.treeList,
              'show-checkbox': true,
              'node-key': this.nodeKey,
              'default-expand-all': true,
              'default-checked-keys': this.defaultCheckedKeys,
            },
            on: {
              'check-change': this.checkChange,
            },
          })}
        </div>
        {this.sortShow && this.reFooter(h)}
      </div>
    );
  }
}
